export class Success {
  /**
   * @type {true}
   */
  success = true;
  data;

  constructor(data) {
    this.data = data;
  }
}
